export default "__VITE_ASSET__CkSZmHWl__"